import { FiEdit2 } from '@react-icons/all-files/fi/FiEdit2'

// edit something (note, cart items)

export const IconEdit = FiEdit2
